import request from '@/utils/request'

export function getUserInfo(data) {
	return request({
		url: '',
		method: 'post',
		data
	})
}
